import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseObservationLogsKey } from '@/hooks'
import { APIErrorResponse, ObservationLog } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostObservationLogsApprove = ({
  id,
}: Pick<ObservationLog, 'id'>): UseMutationResult<
  ObservationLog,
  APIErrorResponse
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const queryKey = getUseObservationLogsKey()

  return useMutation(
    () =>
      client
        .post(`/plannings/observation_logs/${id}/approve/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey)
      },
    }
  )
}
